import React from 'react';
import { messages } from '../common/messages';

class ReportComponent extends React.Component {
  state = {
    reportLoading: false,
    successAlert: false,
    comment: '',
    internalVisible: this.props.visible || false, // manage visibility internally
  };

  // Simulated API call
  reportQuestionAPI = async (payload) => {
    const { apiServices } = this.props;
    const response = await apiServices.saveReport(payload);
    if (response && response.success) {
      return { success: true };
    } else {
      throw new Error(messages.REPORT_SUBMISSION_FAILED);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ internalVisible: this.props.visible });
    }
  }

  handleCancel = () => {
    this.setState({
      successAlert: false,
      comment: '',
      internalVisible: false,
    });
  };

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  handleReportSubmit = async () => {
    const { payload } = this.props;
    const { comment } = this.state;

    if (!comment.trim()) return;

    // Guard: every parent of this component supplies a `payload` shaped
    // like { token, idname, question_id, topic_name, reading_id, ... }.
    // If the parent hasn't loaded its question into state yet,
    // question_id is undefined and JSON.stringify drops the key — the BE
    // then writes a row with question_id=NULL into ea_ques_reports /
    // gmat_focus_ques_reports / etc. and the admin auto-reply has no
    // question to summarise. Bail silently before firing the API call.
    if (!payload || !payload.question_id) {
      console.warn(
        '[ReportComponent] aborting submit — payload missing question_id',
        payload,
      );
      return;
    }

    this.setState({ reportLoading: true });

    const fullPayload = { ...payload, comment };

    try {
      const response = await this.reportQuestionAPI(fullPayload);
      if (response.success) {
        this.setState({ successAlert: true });
      }
    } catch (err) {
      console.error('Submission failed:', err);
    } finally {
      this.setState({ reportLoading: false });
    }
  };

  render() {
    const { internalVisible, successAlert, comment, reportLoading } = this.state;

    if (!internalVisible) return null;

    return (
      <div className='card show_block'>
        <div className='card-header'>Report</div>

        {!successAlert ? (
          <div className='card-block'>
            <div className='row'>
              <div className='col-sm-12'>
                <label>
                  <strong>Comment</strong>
                </label>
              </div>
              <div className='col-sm-12 margin_bottom_10'>
                <textarea
                  rows='6'
                  className='form-control'
                  placeholder='Write comment...'
                  value={comment}
                  onChange={this.handleCommentChange}
                />
              </div>
              <div className='col-sm-12'>
                <button
                  type='button'
                  className='btn btn-primary active pointer_class report-btn'
                  disabled={reportLoading}
                  onClick={this.handleReportSubmit}
                >
                  {reportLoading ? 'Please wait...' : 'Report'}
                </button>
                <button
                  type='button'
                  className='btn btn-danger active pointer_class margin_left_1'
                  onClick={this.handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className='card-block'>
            <div className='row'>
              <div className='col-sm-12 text-center'>
                <img src='/img/success-ic.svg' alt='success' />
                <p>
                  <strong>{messages.REPORT_SEND_SUCCESS_MESSAGE}</strong>
                </p>
                <button className='btn btn-primary' onClick={this.handleCancel}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ReportComponent;



// WEBPACK FOOTER //
// ./src/Components-2025/ReportComponent.jsx